import type { CcofPracticeInfo } from "lib/api-types/schemas";
import { setSuperProperties, track } from "./mixpanel";

export const AnalyticsEvent = {
  SMSCardCapture: "ClientAppSMSCardCapture",
  ManualCardCapture: "ClientAppManualCardCapture",
  PatientSearch: "ClientAppPatientSearch",
  DeleteCard: "ClientAppDeleteCard",
  SaveCardClicked: "ClientAppSaveCardClicked",
  SaveCardSucceeded: "ClientAppSaveCardSucceeded",
  SaveCardFailed: "ClientAppSaveCardFailed",
  MobilePageView: "ClientAppMobilePageView",
  PatientBillingResend: "PatientBillingResend",
} as const;

type EventName = (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];

type EventPayloads = {
  ClientAppSMSCardCapture: {
    surface: "HomeScreen" | "SideModal";
    patient_id: string;
  };
  ClientAppManualCardCapture: { patient_id: string };
  ClientAppPatientSearch: Record<string, never>;
  ClientAppDeleteCard: { patient_id: string };
  ClientAppSaveCardClicked: {
    user: "Staff" | "Patient";
    patient_id: string | null;
    organization_display_name?: string | null;
    organization_legal_name?: string | null;
  };
  ClientAppSaveCardSucceeded: {
    user: "Staff" | "Patient";
    patient_id: string | null;
    organization_display_name?: string | null;
    organization_legal_name?: string | null;
  };
  ClientAppSaveCardFailed: {
    user: "Staff" | "Patient";
    patient_id: string | null;
    organization_display_name?: string | null;
    organization_legal_name?: string | null;
  };
  ClientAppMobilePageView: {
    user: "Patient";
    patient_id: string | null;
    organization_display_name?: string | null;
    organization_legal_name?: string | null;
  };
  PatientBillingResend: { Channel: "SMS" | "Email" };
};

export function trackEvent<E extends EventName>(
  event: E,
  props: EventPayloads[E],
): void {
  track(event, props as Record<string, unknown>);
}

export function setPracticeProperties(practice: CcofPracticeInfo): void {
  setSuperProperties({
    organization_id: practice.practiceId,
    organization_display_name: practice.displayName,
    organization_legal_name: practice.legalName,
  });
}
